module.exports = __webpack_public_path__ + "img/location.137f647a.svg";